import { render, staticRenderFns } from "./WorkflowImport.vue?vue&type=template&id=4f691964&"
import script from "./WorkflowImport.vue?vue&type=script&lang=js&"
export * from "./WorkflowImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports